// extracted by mini-css-extract-plugin
module.exports = {"u_skip":"ResidentAuthLayout_u_skip__Ijr0X","blind":"ResidentAuthLayout_blind__2xmCy","hidden":"ResidentAuthLayout_hidden__34nED","article":"ResidentAuthLayout_article__13giy"};